import React, { useContext, useEffect } from 'react'
import { get } from 'lodash';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import FeeInformation from '../components/FeeInformation';
import InitialComputationModal from './InitialComputationModal';
import CalculationInformation from '../components/CalculationInformation';
import { getCalculation, clearItem  } from '../actions';
import { CALCULATION, INITIAL_COMPUTATION, SELECTED_CALCULATION } from '../constant';

function CalculationModal({ permitId, parentData, requestCalculation, isLoading, list, selectedTab, onClearItem }) {
  
  const calCulationList = useSelector(({ api }) => get(api, `${INITIAL_COMPUTATION}.list`) || [])
  const selectedId = useSelector(({ api }) => get(api, `${SELECTED_CALCULATION}.item`) || '')
  
  const data = calCulationList.find(x => +get(x, 'id') === +selectedId) || {}
  
  const setModal = useContext(ModalContext);

  useEffect(() => {
    requestCalculation(permitId, get(data, 'id'))

    return () => {
      
      onClearItem(SELECTED_CALCULATION, '')
      onClearItem(CALCULATION, [])
    }
  }, [permitId, get(data, 'id')])

  const closeModal = e => {
    e.preventDefault()
    setModal({ isOpen: false });
  }

  const onBack = e => {
    e.preventDefault()
    setModal({
      isOpen: true,
      content: (
        <InitialComputationModal permitId={+permitId} data={parentData} selectedTab={selectedTab} />
      ),
      title: 'Initial Computation',
      modalSize: 'modal-lg',
    });
  }
  
  return (
    <Modal.Body>
      <div className="card-section-content container-fluid card-content-listing p-0">
        <FeeInformation data={get(data, 'attributes')} />
        <div className="position-relative w-100">
          <h3 className="text-success">
            Details
            &nbsp;
            {isLoading && (
              <span className="fas fa-1x fa-spin fa-spinner" />
            )}
          </h3>
          <CalculationInformation permitId={+permitId} initialFeeId={+get(data, 'id')} data={list} />
        </div>
        <hr />
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-center">
              <button
                type="button"
                onClick={onBack}
                className="mt-3 btn btn-secondary "
              >
                <span className="font-weight-bold">
                  Back
                </span>
              </button>
              &nbsp;
              <button
                type="button"
                onClick={closeModal}
                className="mt-3 btn btn-dark "
              >
                <span className="font-weight-bold">
                  Close
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal.Body>
  )
}


CalculationModal.propTypes = {
  permitId: PropTypes.number.isRequired,
  requestCalculation: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  parentData: PropTypes.instanceOf(Object).isRequired,
  selectedTab: PropTypes.number.isRequired,
  onClearItem: PropTypes.instanceOf(Function).isRequired,
}

const mapStateToProps = ({ api }) => {
  return {
    isLoading: api.loading.indexOf(CALCULATION) > -1,
    list: get(api, `${CALCULATION}.list`) || [],
  }
}




export default connect(mapStateToProps, { requestCalculation: getCalculation, onClearItem: clearItem  })(CalculationModal)
